import {Form, Modal} from 'antd';
import {useUpdateAccountMutation} from 'api/generated';
import {Formik} from 'formik';
import {FormItem, Mentions} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {useAdminUsers} from 'hooks/useAdminUsers';
import {omitEmpty} from 'lib/omitEmpty';
import React from 'react';
import * as yup from 'yup';

type Props = {
  accountId?: string | null;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const validationSchema = yup.object().shape({
  note: yup.string().required('Note is required')
});

export const AddAdminNoteModal: React.FC<Props> = ({accountId, isOpen, setIsOpen}) => {
  const adminUsers = useAdminUsers();

  const [updateAccount] = useUpdateAccountMutation();
  if (!accountId) return null;

  const initialValues = {
    note: ''
  };

  const handleSubmit = async (
    {note}: typeof initialValues,
    {setSubmitting}: FormikHelpers<typeof initialValues>
  ) => {
    try {
      await updateAccount({
        variables: {
          input: omitEmpty({
            id: accountId,
            note: note
          })
        }
      });
      setIsOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Add admin note"
            okText="Submit"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            afterClose={resetForm}
            onCancel={() => {
              setIsOpen(false);
            }}>
            <Form layout="vertical">
              <FormItem
                name="note"
                label="Note"
                extra="This message will only be visible to admins.">
                <Mentions
                  rows={4}
                  name="note"
                  options={adminUsers}
                  filterOption={(input, option) =>
                    option.key!.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="You can use @ to mention other admin users"
                />
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
